<!--
  - HOPE U (CHENGDU) NETWORK TECHNOLOGY CO., LTD (HOPEYOO.COM)
  - Copyright (c) 2018- 2020 All Rights Reserved.
  -->

<template>
<!--    <div class="chat-img" :style="{backgroundImage:'url('+bg+')'}" @click="cal"></div>-->
    <div>
<!--        <van-cell is-link @click="showPopup">展示弹出层</van-cell>-->
        <van-popup v-model="show">内容</van-popup>
    </div>
</template>

<script>
// import bg from '@/assets/images/img/chat.png';
import Vue from 'vue';
import { Popup } from 'vant';

Vue.use(Popup);

export default {
  name: 'Chat',
  data() {
    return {
      show: false,
    };
  },
  methods: {
    cal() {
      window.history.go(-1);
    },
    showPopup() {
      this.show = true;
    },
  },
};
</script>


<style type="text/scss" lang="scss">
    .chat-img {
        width: 100%;
        background-size: 110%;
        height: 100vh;
        background-position: center top;
        background-repeat: no-repeat;
    }
</style>
